import { time2Pixel } from '~/Util'

export const getDragAssetsLeftOffset = (draggingAssets, scale, transitions, isExternalSource) => {
  if (isExternalSource) {
    let offset = 0
    return draggingAssets.reduce((result, asset) => {
      const leftOffset = time2Pixel(offset, scale)
      // eslint-disable-next-line no-param-reassign
      result[asset.id] = leftOffset
      offset += asset.duration
      return result
    }, {})
  }
  const sortingAssets = draggingAssets.sort((a, b) => a.startTime - b.startTime)
  const offset = sortingAssets?.[0]?.startTime
  return sortingAssets.reduce((result, asset) => {
    const dissolveORFadeIn = transitions.find(tr => tr.isAttachedToRight(asset.id))
    const transitionOffset = (dissolveORFadeIn?.duration ?? 0) * -1
    const leftOffset = time2Pixel(asset.startTime - offset - transitionOffset, scale)
    // eslint-disable-next-line no-param-reassign
    result[asset.id] = leftOffset
    return result
  }, {})
}
